// Google Analytics tracking utilities

declare global {
  interface Window {
    gtag?: (
      command: string,
      targetId: string,
      config?: Record<string, unknown>
    ) => void;
  }
}

export const trackPageView = (url: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-GG5JX7VE7T', {
      page_path: url,
    });
  }
};

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

export const trackFormSubmission = (formName: string) => {
  trackEvent('form_submission', 'engagement', formName);
};

export const trackMusicPlay = (platform: string) => {
  trackEvent('music_play', 'engagement', platform);
};

export const trackSocialClick = (platform: string) => {
  trackEvent('social_click', 'engagement', platform);
};

export const trackArtistSubmission = () => {
  trackEvent('artist_submission', 'conversion', 'submit_music_form');
};
